<div class="node-icon-chooser-panel mat-elevation-z8">
  <mat-card appearance="outlined">
  <mat-card-header>
    <h4 mat-card-subtitle>{{'node-icon-chooser.popup.choose-icon' | translate}}</h4>
  </mat-card-header>
  <mat-card-content class="icons-grid">
  @for (icon of icons; track icon) {
    <button mat-icon-button (click)="iconClicked(icon)"  [class.selected-icon]="processIcon() === icon">
      <mat-icon class="selectable-icon material-symbols-unfilled">{{icon}}</mat-icon>
    </button>
  }
  </mat-card-content>
</mat-card>
</div>
